import {
  Flex,
  Button,
  Box,
  IconButton,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  FaChevronLeft,
  FaChevronRight,
  FaAngleDoubleRight,
} from "react-icons/fa";
import { Desktop, Mobile } from "~/components/MediaQuery";

export default function OnboardingNavigation({
  readyToContinue,
  onNext,
  onBack,
  showBack,
  showSkip = false,
  onSkip,
}) {
  return (
    <Flex pt="8" direction="row" justify="space-between">
      <Box flex="1">
        {showBack && (
          <>
            <Desktop>
              <Button
                leftIcon={<FaChevronLeft />}
                backgroundColor={useColorModeValue(
                  "light.background.strong",
                  "dark.background.strong"
                )}
                variant="ghost"
                colorScheme="gray"
                px="8"
                onClick={() => onBack()}
              >
                Atrás
              </Button>
            </Desktop>
            <Mobile>
              <IconButton
                backgroundColor={useColorModeValue(
                  "light.background.strong",
                  "dark.background.strong"
                )}
                colorScheme="gray"
                aria-label="Atrás"
                icon={<FaChevronLeft />}
                onClick={() => onBack()}
              />
            </Mobile>
          </>
        )}
      </Box>
      {showSkip && (
        <Button
          rightIcon={<FaAngleDoubleRight />}
          backgroundColor={useColorModeValue(
            "light.background.strong",
            "dark.background.strong"
          )}
          variant="ghost"
          colorScheme="gray"
          px="8"
          mr="4"
          onClick={() => onSkip()}
        >
          Omitir
        </Button>
      )}
      <Button
        rightIcon={<FaChevronRight />}
        px="8"
        onClick={() => onNext()}
        isDisabled={!readyToContinue}
      >
        Continuar
      </Button>
    </Flex>
  );
}
